export const downloadXlsxFile = ({
  file,
  fileName,
  extension
}: {
  file: Blob;
  fileName: string;
  extension?: string;
}) => {
  const url = window.URL.createObjectURL(file);
  const downloadLink = document.createElement('a');
  const completeFileName = `${fileName}.${extension || 'xlsx'}`;
  downloadLink.href = url;
  downloadLink.download = completeFileName;
  downloadLink.click();
  downloadLink.parentNode?.removeChild(downloadLink);
  window.URL.revokeObjectURL(url);
};
